import React, { Component } from 'react';
import { Button, Col, Input, InputGroup, InputGroupAddon, InputGroupText, Row } from 'reactstrap';
import { Redirect } from 'react-router-dom';
import firebase from '../../../firebase.js';
import logo from '../../../assets/img/title-blue.png';
import LinkedinSDK from 'react-linkedin-sdk';

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      login: false,
      signup: false,
      warning: "",
      info: "",
      showVerify: false,
      forget: false,
      reset: false,
      isdisabled: false,
    };
    this.user_name = "";
    this.pwd = "";
    this.toggleLogin = this.toggleLogin.bind(this);
    this.toggleForget = this.toggleForget.bind(this);
    this.toggleShowForget = this.toggleShowForget.bind(this);
    this.toggleRegister = this.toggleRegister.bind(this);
    this.updateEmailInput = this.updateEmailInput.bind(this);
    this.toggleGoogleSignUp = this.toggleGoogleSignUp.bind(this);
    this.toggleTwitterSignUp = this.toggleTwitterSignUp.bind(this);
    this.toggleSendVerification = this.toggleSendVerification.bind(this);
    
  }

  componentDidMount() {
    let userId = localStorage.getItem('user_id');
    if (userId !== null) {
      let user_name = localStorage.getItem('user_name');
      let user_email = localStorage.getItem('user_email');
      this.saveUser2Db(user_name, user_email, userId);
      window.location = "/dashboard";
    }
  }

  updateEmailInput(evt) {
    this.user_email = evt.target.value;
    this.setState({warning : "", showVerify: false});
  }

  updatePwdInput(evt) {
    this.pwd = evt.target.value;
    this.setState({warning : "" , showVerify: false});
  }

  saveUser2Db(user_name, user_email, userId) {

    let self = this;
    firebase.database().ref('/users/').once('value').then(function(snapshot) {
      let local_keys = [];
      let local_values = snapshot.val();
      if (snapshot.val()) {
        local_keys =  Object.keys(snapshot.val());
      }
      if(local_values[userId] !== undefined && local_values[userId]["image"] !== undefined) {
         localStorage.setItem("image_head",local_values[userId]["image"])
      }

      let dd = new Date()
      let month = dd.getMonth() < 10 ? "0" + (dd.getMonth() + 1).toString() : dd.getMonth() + 1;
      let day = dd.getDate() < 10 ? "0" + dd.getDate().toString() : dd.getDate();
      let hr = dd.getHours() < 10 ? "0" + dd.getHours().toString() : dd.getHours();
      let min = dd.getMinutes() < 10 ? "0" + dd.getMinutes().toString() : dd.getMinutes();
      let sec = dd.getSeconds() < 10 ? "0" + dd.getSeconds().toString() : dd.getSeconds();
      let timestamp = '' + dd.getFullYear() + month + day + hr + min + sec;

      firebase.database().ref('/codes/').once('value').then(function(snapshot) {
        let keys = [];
        if (snapshot.val()) {
          keys =  Object.keys(snapshot.val());
        }
        let freeCode = 0;
        freeCode = self.getAccessCode(keys, 4);
        let image = "";
        if(local_values[userId] !== undefined && local_values[userId]["image"] !== undefined) {
            image = local_values[userId]["image"]? local_values[userId]["image"]: "";
        }
        let createAt = "";
        if(local_values[userId] !== undefined && local_values[userId]["createAt"] !== undefined) {
          createAt = local_values[userId]["createAt"];
        } else {
          createAt = timestamp.toString();
        }
        
        let postData = {
          user_name: user_name,
          user_email: user_email,
          user_id : userId,
          createAt: createAt,
          updateAt: timestamp,
          role: 0,
          image: image,
          accessCode: freeCode,
          online: true,
          finalround: {
            enable: false
          }
        };

        let codeData = {
          used: true,
          user_email: user_email,
          user_id : userId,
        }

        var updates = {};
        if (local_keys === null) {
          //init
          updates['/users/' + userId] = postData;
          updates['/codes/' + freeCode] = codeData; 
          self.sendEmailWithCode(user_email, freeCode);
          firebase.database().ref().update(updates);
        }
        let isthere = local_keys.filter((key) => key === userId);
        if (!isthere || isthere.length === 0) {
          updates['/users/' + userId] = postData;
          updates['/codes/' + freeCode] = codeData; 
          self.sendEmailWithCode(user_email, freeCode);
          firebase.database().ref().update(updates);
        } else {
          updates['/users/' + userId + '/updateAt/' ] = timestamp;
          firebase.database().ref().update(updates);
        }

        localStorage.setItem('user_id', userId.toString());
        localStorage.setItem('user_name', user_name.toString());
        localStorage.setItem('user_email', user_name.toString());
        localStorage.setItem('image_head', image.toString());

        self.setState({
          login: true,
        });
      });
     
    });
  }

  getAccessCode(keys, range) {
    let start = Math.pow(10, range - 1);
    let end = Math.pow(10, range) - 1;
    for (let i = start; i <= end; i++) {
      if (keys === undefined) {
        return i;
      }
      if (keys.indexOf(i.toString()) === -1) {
        return i;
      }
    }
  }

  sendEmailWithCode(email, code) {
    let to = "Client <" + email + ">";
    let text = "Your access code is " + code;
    fetch('https://api.smtp2go.com/v3/email/send', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        "api_key": "api-ECC1D49AA46711E89D0AF23C91C88F4E",
        "to": [to],
        "sender": "AbilitàXR <hello@abilitaxr.com>",
        "subject": "Your Access Code",
        "text_body": text,
        "html_body": "<h1>" + text + "</h1>",
        })
        }).then(function(response) {
        return response.json();
        });
  }

  toggleFaceBookSignUp() {
    let self = this;
    var provider = new firebase.auth.FacebookAuthProvider();
    firebase.auth().signInWithPopup(provider).then(function(result) {
      var token = result.credential.accessToken;
      var user = result.user;
      console.log(user);
      console.log(token);
      console.log(user);
      let userId = firebase.auth().currentUser.uid;
      self.saveUser2Db(user.displayName, user.email, userId);
      
   }).catch(function(error) {
     console.log(error.message);
      self.setState({warning : error.code});
   });
  }

  toggleSendVerification() {
    firebase.auth().currentUser.sendEmailVerification();
  }

  toggleGoogleSignUp() {
    let self = this;
    const provider = new firebase.auth.GoogleAuthProvider();
    firebase.auth().signInWithPopup(provider).then(function(result) {
      var token = result.credential.accessToken;
      var user = result.user;
      console.log(user);
      console.log(token);
      console.log(user);
      let userId = firebase.auth().currentUser.uid;
      self.saveUser2Db(user.displayName, user.email, userId);
   }).catch(function(error) {
      self.setState({warning : error.message});
   });
  }

  toggleTwitterSignUp() {
    let self = this;
    const provider = new firebase.auth.TwitterAuthProvider();
    firebase.auth().signInWithPopup(provider).then(function(result) {
      var token = result.credential.accessToken;
      var user = result.user;
      console.log(user);
      console.log(token);
      console.log(user);
      let userId = firebase.auth().currentUser.uid;
      self.saveUser2Db(user.displayName, user.email, userId);
      
    }).catch(function(error) {
        this.setState({info : ""});
        self.setState({warning : error.code});
    });
  }

  toggleForget() {
    let self = this;
    if (this.user_email === "") {
      this.setState({info : ""});
      this.setState({warning : "Please enter your registered email id."});
      return;
    }
    firebase.auth().sendPasswordResetEmail(this.user_email).then(e => {
      self.setState({forget: false});
    }).catch (e => {
      this.setState({info : ""});
      this.setState({warning : e.message});
    })
  }

  toggleShowForget() {
    this.setState({info : ""});
    this.setState({warning : ""});
    this.setState({forget: !this.state.forget});
  }

  toggleLogin() {
    this.setState({info : "Logging In. Please wait..."});
    if (this.user_email === "" && this.pwd === "") {
      this.setState({info : ""});
      this.setState({warning : "User email or password is wrong."});
      return;
    }
    console.log('login')
    let self = this;
    firebase.auth().signInWithEmailAndPassword(this.user_email, this.pwd).then(value => {
      let userId = firebase.auth().currentUser.uid;
      
      if (firebase.auth().currentUser.emailVerified === false) {
        self.setState({info : ""});
        self.setState({warning : "Please verify your email and try again.", showVerify: true});
      } else {
        self.saveUser2Db(firebase.auth().currentUser.displayName, this.user_email, userId);
      }
      
    }).catch(e => {
      self.setState({info : ""});
      self.setState({warning : e.message});
    })
  }
  toggleRegister() {
    this.setState({
      signup: true,
    });
  }
  renderRedirect = () => {
    if (this.state.login) {
      return <Redirect to= { '/dashboard/'} />
    }
    if (this.state.signup) {
      return <Redirect to= { '/register/'} />
    }
    if (this.state.reset) {
      return <Redirect to= { '/register/'} />
    }
  }
  render() {
    const responseLinkedin = response => {
      console.log(response)
    }
    return (
      <div className="app flex-row font-Poppins">
      {this.renderRedirect()}
          <img alt = "" src = {logo} className= "login-title" />
          <Row className="login header-100-vh-1">
            <Col className="login-col-a align-items-center login-col-width">
                <div className="login-div-a mt-5 pt-5 p-4">
                    <h3 className="font-weight-400 font-Poppins">Welcome back!</h3>
                    <br />
                    <br />
                    <h6 className="pb-2 color-red text-center">{this.state.warning}
                     {this.state.showVerify ? <Button onClick={() => this.toggleSendVerification()} color="link" className= "ml-2 mr-2 login-text-color-spec px-0 pb-2">Resend verification</Button> : null} 
                     </h6>
                    <h6 className="pb-2 color-blue text-center">{this.state.info}
                     </h6>
                    <InputGroup className="mb-3">
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="icon-user"></i>
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input disabled={this.state.isdisabled}  type="text" onChange={  (e) => this.updateEmailInput(e)} placeholder="Email" />
                    </InputGroup>

                    {
                      this.state.forget === false ?
                      <InputGroup className="mb-4">
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="icon-lock"></i>
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input disabled={this.state.isdisabled} type="password" onChange={(e) =>this.updatePwdInput(e)}  placeholder="Password" />
                      </InputGroup> : null
                    }
                    
                    <Row>

                        {
                          this.state.forget ?
                          <Col xs="6">
                            <Button color="link" className="login-text-color-gray px-0" onClick={() => this.toggleShowForget()}>Back</Button>
                          </Col> :  null 
                        }

                       {
                         this.state.forget ? 
                         <Col xs="6" className="text-right">
                          <Button className="login-text-color px-4" onClick={() => this.toggleForget()}  >Send</Button>
                        </Col> : null
                       }

                       {
                         this.state.forget ? null :
                         <Col xs="6">
                            <Button color="link" className="login-text-color-gray px-0" onClick={() => this.toggleShowForget()}>Forgot password?</Button>
                          </Col>
                       }

                       {
                         this.state.forget ? null :
                         <Col xs="6" className="text-right">
                            <Button disabled={this.state.isdisabled} className="login-text-color px-4" onClick={() => this.toggleLogin()}  >Sign In</Button>
                          </Col>
                       }

                    </Row>
                    <br />
                    <br />
                    <div className = "login-div-b"> 
                      <h6 className = "font-weight-400">
                      <Row>
                        <Col md="5" sm = "5" lg = "5" xs="5" className=" m-0 p-0">
                        <hr className="logo-line"/>
                        </Col>
                        <Col className = "mt-2" md="2" sm = "2" lg = "2" xs="2">
                        Or
                        </Col>
                        <Col md="5" sm = "5" lg = "5" xs="5" className="m-0 p-0">
                        <hr className="logo-line"/>
                        </Col>
                      </Row>
                      </h6>
                      <br />
                      <Row>
                        <Col xs="4">
                          <Button  onClick={() => this.toggleFaceBookSignUp()}className="border-radius-50 btn-facebook btn-brand icon mr-1 mb-1"><i className="border-radius-50 fa fa-facebook"></i></Button>
                        </Col>
                        <Col xs="4">
                          <Button onClick={() => this.toggleTwitterSignUp()} className="border-radius-50 btn-twitter btn-brand icon mr-1 mb-1"><i className="border-radius-50 fa fa-twitter"></i></Button>
                        </Col>
                        { /*<Col xs="3">
                          <LinkedinSDK
                            clientId="81uhyk6in6rzql"
                            callBack={responseLinkedin}
                            fields=":(id,num-connections,picture-urls::(original))"
                            className={'border-radius-50 btn-linkedin btn-linkedin-padding btn-brand icon mr-1 mb-1'}
                            loginButtonText={<i className="border-radius-50 fa fa-linkedin"></i>}
                            logoutButtonText={''}
                            buttonType={'button'}
                          />
                        </Col> */ }
                        <Col xs="2">
                          <Button onClick={() => this.toggleGoogleSignUp()}  className="border-radius-50 btn-google-plus btn-brand icon mr-1 mb-1"><i className="border-radius-50 fa fa-google-plus"></i></Button>
                        </Col>
                      </Row>
                      <br />
                      <br />
                      <br />
                      <h6 className="login-bottom"> Don't you have an account? SignUp <Button onClick={() => this.toggleRegister()} color="link" className= "login-text-color-spec px-0 pb-2">Here</Button> </h6> 
                    </div>
                    
                </div>
            </Col>
            <Col className="login-b">
            </Col>
          </Row>
      </div>
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/views/Pages/Login/Login.js